import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext();
export const useSettings = () => useContext(SettingsContext);

// Extract slug from URL path e.g. /school/slicktech_high_school/login -> slicktech_high_school
function getSlugFromUrl() {
  const match = window.location.pathname.match(/\/school\/([^/]+)/);
  return match ? match[1] : (localStorage.getItem('sms_slug') || '');
}

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    primary_color: '#1565c0', secondary_color: '#e53935',
    theme_mode: 'light', school_name: 'School Management System'
  });

  const fetchSettings = async () => {
    try {
      const slug = getSlugFromUrl();
      const headers = slug ? { 'X-School-Slug': slug } : {};
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/settings`, { headers });
      if (res.data.success && res.data.data) setSettings(res.data.data);
    } catch {}
  };

  useEffect(() => { fetchSettings(); }, []);

  const refreshSettings = fetchSettings;

  return (
    <SettingsContext.Provider value={{ settings, setSettings, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
